import { axiosInstance } from "@/lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Hook for inviting employees
 */
export const useInviteEmployees = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      departmentId,
      emails,
    }: {
      departmentId: string;
      emails: string[];
    }) => {
      console.log("📤 Sending invitation request to backend:", {
        departmentId,
        emails,
        emailsCount: emails.length,
        endpoint: "/api/v1/authentication/company/invite-employees"
      });
      
      const { data } = await axiosInstance.post("/api/v1/authentication/company/invite-employees", {
        departmentId,
        invitedEmployees: emails,
      });
      
      console.log("✅ Invitation request successful:", data);
      return data;
    },
    onSuccess: () => {
      // Invalidate employee queries to refresh data
      queryClient.invalidateQueries({ queryKey: ["companyEmployees"] });
      queryClient.invalidateQueries({ queryKey: ["department"] });
    },
    onError: (error: any) => {
      console.error("❌ Invitation request failed:", {
        error,
        message: error?.response?.data?.message,
        status: error?.response?.status
      });
    },
  });
};

/**
 * Hook for inviting employees (company admin version)
 */
export const useInviteEmployeesCompany = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ emails }: { emails: string[] }) => {
      const { data } = await axiosInstance.post("/api/v1/companies/invite-employees", {
        emails,
      });
      return data;
    },
    onSuccess: () => {
      // Invalidate employee queries to refresh data
      queryClient.invalidateQueries({ queryKey: ["companyEmployees"] });
    },
  });
};
